export type ZenginFileAccept = "text/zengin" | "text/csv";

export type ZenginClosingDay = "15" | "month-end";

export class ZenginDownloadError extends Error {
  constructor(
    public readonly status: number,
    message: string,
  ) {
    super(message);
    this.name = "ZenginDownloadError";
  }
}

export type DownloadZenginParams = {
  yearMonth: string;
  closingDay?: ZenginClosingDay;
  accept: ZenginFileAccept;
};

export function buildZenginDownloadPath(params: DownloadZenginParams) {
  const searchParams = new URLSearchParams();
  searchParams.set("yearMonth", params.yearMonth);

  if (params.closingDay) {
    searchParams.set("closingDay", params.closingDay);
  }

  return `/storage/zengin?${searchParams.toString()}`;
}
